<template>
    <el-select :size="size" v-model="printerList[printer]" :placeholder="$d('请选择打印机')" @change="setPrinter">
        <el-option v-for="(item, index) in printerList"
                   :key="index"
                   :label="item"
                   :value="index">
            <span class="left">{{ item }}</span>
            <span class="right" v-if="index === lastUsed">{{ $d('最近使用') }}</span>
        </el-option>
    </el-select>
</template>

<script>
import {printer} from '@/const/print'

export default {
    name: 'etao-printer',
    props: {
        templateId: String,
        size: {
            type: String,
            default: 'mini'
        }
    },
    watch: {
        templateId: {
            handler: function (id) {
                setTimeout(() => {
                    this.getPrinterList(() => {
                        if (this.template.category === 'LODOP') {
                            this.printer = localStorage.getItem('emis-label-printer-lodop')
                        } else if (this.template.category === 'BARTENDER') {
                            this.printer = localStorage.getItem('emis-label-printer-bartender')
                        }
                        if (this.printer) {
                            this.setPrinter(this.printer)
                        }
                    }, id)
                }, 1000)
            },
            deep: true
        }
    },
    methods: {
        setPrinter: function (value) {
            // console.log(value)
            this.lastUsed = value
            if (this.template.category === 'LODOP') {
                localStorage.setItem('emis-label-printer-lodop', value)
            } else if (this.template.category === 'BARTENDER') {
                localStorage.setItem('emis-label-printer-bartender', value)
            }
            // console.log(localStorage.getItem('emis-label-printer-lodop'))
            this.$emit('input', value)
            this.$emit('change', value)
        },
        getPrinterList: function (callback, templateId) {
            if (templateId === 'LODOP') {
                this.template.category = 'LODOP'
                let list = printer(this.template)
                this.$set(this, 'printerList', list)
                this.$nextTick(callback)
            } else {
                this.etao.requests.get({
                    url: '/etao-basic/print-template/detail',
                    data: {
                        id: templateId
                    },
                    successMessage: false,
                    success: res => {
                        if (res.code === 200) {
                            let list = printer(res.data)
                            this.template = res.data
                            if (list) {
                                console.log(list)
                                this.$set(this, 'printerList', list)
                                this.$nextTick(callback)
                            }
                        }
                    }
                })
            }
        }
    },
    data () {
        return {
            template: {},
            printerList: [],
            printer: '',
            lastUsed: '',
            lodop: this.etao.lodop()
        }
    },
    mounted () {
    }
}
</script>

<style scoped>
.left {
    float: left;
}

.right {
    float: right;
    color: #8492a6;
    font-size: 13px;
}
</style>



// WEBPACK FOOTER //
// src/comp/etao-printer.vue